import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent {
  @Input() feature: any;
  @Input() maps: any[];
  @Output() featureChange = new EventEmitter<any>();

  onMapChange() {
    this.featureChange.emit(this.feature);
  }
}